import { en_US, NzI18nInterface, ro_RO } from "ng-zorro-antd/i18n";

export type Language = "en" | "ro";

export const DEFAULT_LANGUAGE: Language = "en";

export const SUPPORTED_LANGUAGES: Language[] = ["en", "ro"];

export const NZ_LOCALES: Record<Language, NzI18nInterface> = {
  en: en_US,
  ro: ro_RO
};

/** Maps our app language to the Angular locale id used by DatePipe/CurrencyPipe/etc. */
export const ANGULAR_LOCALES: Record<Language, string> = {
  en: "en-US",
  ro: "ro"
};
